const { default: ApiService } = require("./api.service");

const DoctorFeedbackService = {
    // Ottieni tutti i feedback per un dottore
    getDoctorFeedbacks: (therapistId) => 
        ApiService.fetch(`doctors/${therapistId}/feedbacks`),
    
    // Ottieni i feedback lasciati dall'utente corrente
    getMyFeedbacks: () => 
        ApiService.fetch('patient/feedbacks'),
    
    // Controlla se l'utente può lasciare un feedback per un dottore
    canLeaveFeedback: (therapistId) => 
        ApiService.fetch(`doctors/${therapistId}/can-leave-feedback`),
    
    // Invia un nuovo feedback
    leaveFeedback: (data) => 
        ApiService.fetch('feedbacks', {
            method: 'POST',
            body: JSON.stringify(data)
        }),
    
    // Aggiorna un feedback esistente
    updateFeedback: (feedbackId, data) => 
        ApiService.fetch(`feedbacks/${feedbackId}`, {
            method: 'PUT',
            body: JSON.stringify(data)
        }),
    
    // Elimina un feedback
    deleteFeedback: (feedbackId) => 
        ApiService.fetch(`feedbacks/${feedbackId}`, {
            method: 'DELETE'
        }),
    
    // Admin: Ottieni tutti i feedback
    adminGetAllFeedbacks: () => 
        ApiService.fetch('admin/feedbacks'),
    
    // Admin: Pubblica/nascondi feedback
    adminTogglePublish: (feedbackId) => 
        ApiService.fetch(`admin/feedbacks/${feedbackId}/toggle-publish`, {
            method: 'PUT'
        })
};

export default DoctorFeedbackService;